import * as dashboardChargeProTypes from 'js/constants/chargeDashboardPro-types';

function chargeDashboardProReducer(
  state = {
    TenMinutal: [],
    TenMinutalLoading: true,
    TenMinutalError: false,
    FiveMinutal: [],
    FiveMinutalLoading: true,
    FiveMinutalError: false,
    Harmonic: [],
    HarmonicLoading: true,
    HarmonicError: false,
    FlickerPlt: [],
    FlickerPltLoading: true,
    FlickerPltError: false,
    Notification: [],
    NotificationLoading: true,
    NotificationError: false,
  },
  action
) {
  switch (action.type) {
    case dashboardChargeProTypes.GET_CHARGE_DASHBOARD_10_MINUTAL_PRO:
      return {
        ...state,
        TenMinutal: action.payload,
        TenMinutalLoading: false,
        TenMinutalError: false,
      };
    case dashboardChargeProTypes.GET_CHARGE_DASHBOARD_10_MINUTAL_PRO_SUCCESS:
      return {
        ...state,
        TenMinutal: action.payload,
        TenMinutalLoading: false,
        TenMinutalError: false,
      };
    case dashboardChargeProTypes.GET_CHARGE_DASHBOARD_10_MINUTAL_PRO_FAILURE:
      return {
        ...state,
        TenMinutal: [],
        TenMinutalLoading: false,
        TenMinutalError: true,
      };
    case dashboardChargeProTypes.GET_CHARGE_DASHBOARD_5_MINUTAL_PRO:
      return {
        ...state,
        FiveMinutal: action.payload,
        FiveMinutalLoading: false,
        FiveMinutalError: false,
      };
    case dashboardChargeProTypes.GET_CHARGE_DASHBOARD_5_MINUTAL_PRO_SUCCESS:
      return {
        ...state,
        FiveMinutal: action.payload,
        FiveMinutalLoading: false,
        FiveMinutalError: false,
      };
    case dashboardChargeProTypes.GET_CHARGE_DASHBOARD_5_MINUTAL_PRO_FAILURE:
      return {
        ...state,
        FiveMinutal: [],
        FiveMinutalLoading: false,
        FiveMinutalError: true,
      };
    case dashboardChargeProTypes.GET_CHARGE_DASHBOARD_HARMONIC_PRO:
      return {
        ...state,
        Harmonic: action.payload,
        HarmonicLoading: false,
        HarmonicError: false,
      };
    case dashboardChargeProTypes.GET_CHARGE_DASHBOARD_HARMONIC_PRO_SUCCESS:
      return {
        ...state,
        Harmonic: action.payload,
        HarmonicLoading: false,
        HarmonicError: false,
      };
    case dashboardChargeProTypes.GET_CHARGE_DASHBOARD_HARMONIC_PRO_FAILURE:
      return {
        ...state,
        Harmonic: [],
        HarmonicLoading: false,
        HarmonicError: true,
      };
    case dashboardChargeProTypes.GET_CHARGE_DASHBOARD_FLICKER_PLT_PRO_SUCCESS:
      return {
        ...state,
        FlickerPlt: action.payload,
        FlickerPltLoading: false,
        FlickerPltError: false,
      };
    case dashboardChargeProTypes.GET_CHARGE_DASHBOARD_FLICKER_PLT_PRO_FAILURE:
      return {
        ...state,
        FlickerPlt: [],
        FlickerPltLoading: false,
        FlickerPltError: true,
      };
    case dashboardChargeProTypes.GET_CHARGE_DASHBOARD_NOTIFICATION_SUCCESS:
      return {
        ...state,
        Notification: action.payload,
        NotificationLoading: false,
        NotificationError: false,
      };
    case dashboardChargeProTypes.GET_CHARGE_DASHBOARD_NOTIFICATION_FAILURE:
      return {
        ...state,
        Notification: [],
        NotificationLoading: false,
        NotificationError: true,
      };
    default:
      return state;
  }
}

export default chargeDashboardProReducer;
